import {
  ProductListGroup,
  ProductListGroupId,
  Section,
} from "@ubnt/store.core/lib/constants/modelCompareData/types";
import { starterKits } from "@ubnt/store.core/lib/constants/modelCompareData/data/product-list-groups/starterKits";
import { readersAndIntercom } from "@ubnt/store.core/lib/constants/modelCompareData/data/product-list-groups/readersAndIntercom";
import { controlHubs as accessHubs } from "@ubnt/store.core/lib/constants/modelCompareData/data/product-list-groups/controlHubs";
import { AccessHubs } from "@ubnt/store.core/lib/constants/modelCompareData/data/AccessHubs";
import { StarterKits } from "@ubnt/store.core/lib/constants/modelCompareData/data/StarterKit";
import { Readers } from "@ubnt/store.core/lib/constants/modelCompareData/data/Readers";

export type DoorAccessGroupId =
  | ProductListGroupId.StarterKits
  | ProductListGroupId.ControlHubs
  | ProductListGroupId.ReadersAndIntercom;

export const doorAccessTabs: Record<DoorAccessGroupId, ProductListGroup> = {
  [ProductListGroupId.StarterKits]: starterKits,
  [ProductListGroupId.ControlHubs]: accessHubs,
  [ProductListGroupId.ReadersAndIntercom]: readersAndIntercom,
};

export const doorAccessSections: Record<DoorAccessGroupId, Section> = {
  [ProductListGroupId.StarterKits]: StarterKits,
  [ProductListGroupId.ControlHubs]: AccessHubs,
  [ProductListGroupId.ReadersAndIntercom]: Readers,
};
